import { ResponseGenerator } from 'common/type';
import { call, put, takeLatest } from 'redux-saga/effects';

import {
  getFilterBLInformationAPI,
  getDetailCargoInfoAPI,
  updateCargoInfoAPI,
  deleteCargoInfoAPI,
  addCargoInfoAPI,
} from './api';
import {
  filterBlInformation,
  filterBlInformationSuccess,
  detailCargoInfo,
  detailCargoInfoSuccess,
  updateCargoInfor,
  updateCargoInforSuccess,
  deleteCargoInforSuccess,
  deleteCargoInfor,
  addCargoInfoSuccess,
  addCargoInfor,
  filterBlInformationFailure,
  addCargoInfoFailure,
  deleteCargoInforFailure,
  updateCargoInforFailure,
  detailCargoInfoFailure,
} from './slice';

function* filterBlInformationSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(getFilterBLInformationAPI, payload);
    yield put(filterBlInformationSuccess(response.data));
  } catch (error) {
    yield put(
      filterBlInformationFailure({
        loading: false,
      })
    );
  }
}
function* getDetailCargoInformationSaga({ payload }: any) {
  const { strHblNo, strCreSysIdH, rcvCnt, onFail } = payload;
  try {
    const response: ResponseGenerator = yield call(getDetailCargoInfoAPI, { strHblNo, strCreSysIdH, rcvCnt });
    yield put(detailCargoInfoSuccess(response));
  } catch (error) {
    yield put(
      detailCargoInfoFailure({
        loading: false,
      })
    );
    yield put(onFail());
  }
}
function* updateDetailCargoSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(updateCargoInfoAPI, payload);
    yield put(updateCargoInforSuccess(response));
  } catch (error) {
    yield put(
      updateCargoInforFailure({
        loading: false,
      })
    );
  }
}
function* deleteDetailCargoSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(deleteCargoInfoAPI, payload);
    yield put(deleteCargoInforSuccess(response));
  } catch (error) {
    yield put(
      deleteCargoInforFailure({
        loading: false,
      })
    );
  }
}
function* addDetailCargoSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(addCargoInfoAPI, payload);
    yield put(addCargoInfoSuccess(response));
  } catch (error: any) {
    yield put(
      addCargoInfoFailure({
        loading: false,
      })
    );
  }
}

function* watchBlMaster() {
  yield takeLatest(filterBlInformation, filterBlInformationSaga);
  yield takeLatest(detailCargoInfo, getDetailCargoInformationSaga);
  yield takeLatest(updateCargoInfor, updateDetailCargoSaga);
  yield takeLatest(deleteCargoInfor, deleteDetailCargoSaga);
  yield takeLatest(addCargoInfor, addDetailCargoSaga);
}

export default watchBlMaster;
